import {TPeriodPickerValue} from '@edna/components';
import {TCurrency} from '@edna/utils';

import {EChannelType, EOperatorName, TItemId} from 'src/constants';
import {TDocumentType} from 'src/containers/Billing';

export enum EPaymentTab {
  REPLENISHMENT = 'replenishment',
  ACCOUNT_STATEMENT = 'accountStatement',
  DOCUMENTATION = 'documentation',
}

export const PAYMENT_TABS = Object.values(EPaymentTab);

export enum EDebtPaymentType {
  WHATSAPP_LICENSE_INIT_PAYMENT = 'WHATSAPP_LICENSE_INIT_PAYMENT',
  WHATSAPP_LICENSE_RENEWAL_PAYMENT = 'WHATSAPP_LICENSE_RENEWAL_PAYMENT',
  WHATSAPP_AMAU_PAYMENT = 'WHATSAPP_AMAU_PAYMENT',
  VIBER_LICENSE_INIT_PAYMENT = 'VIBER_LICENSE_INIT_PAYMENT',
  VIBER_LICENSE_RENEWAL_PAYMENT = 'VIBER_LICENSE_RENEWAL_PAYMENT',
  SMS_LICENSE_INIT_PAYMENT = 'SMS_LICENSE_INIT_PAYMENT',
  SMS_LICENSE_RENEWAL_PAYMENT = 'SMS_LICENSE_RENEWAL_PAYMENT',
  SMS_RECURRENT_BILLED = 'SMS_RECURRENT_BILLED',
  SMS_TEMPLATE_BILLED = 'SMS_TEMPLATE_BILLED',
  VIBER_RECURRENT_PAYMENT = 'VIBER_RECURRENT_PAYMENT',
  MAX_BOT_LICENSE_INIT_PAYMENT = 'MAX_BOT_LICENSE_INIT_PAYMENT',
  MAX_BOT_LICENSE_RENEWAL_PAYMENT = 'MAX_BOT_LICENSE_RENEWAL_PAYMENT',
  MAX_LICENSE_INIT_PAYMENT = 'MAX_LICENSE_INIT_PAYMENT',
  MAX_LICENSE_RENEWAL_PAYMENT = 'MAX_LICENSE_RENEWAL_PAYMENT',
  TELEGRAM_LICENSE_INIT_PAYMENT = 'TELEGRAM_LICENSE_INIT_PAYMENT',
  TELEGRAM_LICENSE_RENEWAL_PAYMENT = 'TELEGRAM_LICENSE_RENEWAL_PAYMENT',
}

export const channelByDebtPaymentHash = {
  [EDebtPaymentType.WHATSAPP_LICENSE_INIT_PAYMENT]: EChannelType.WHATSAPP,
  [EDebtPaymentType.WHATSAPP_LICENSE_RENEWAL_PAYMENT]: EChannelType.WHATSAPP,
  [EDebtPaymentType.WHATSAPP_AMAU_PAYMENT]: EChannelType.WHATSAPP,
  [EDebtPaymentType.VIBER_LICENSE_INIT_PAYMENT]: EChannelType.VIBER,
  [EDebtPaymentType.VIBER_LICENSE_RENEWAL_PAYMENT]: EChannelType.VIBER,
  [EDebtPaymentType.VIBER_RECURRENT_PAYMENT]: EChannelType.VIBER,
  [EDebtPaymentType.SMS_LICENSE_INIT_PAYMENT]: EChannelType.SMS,
  [EDebtPaymentType.SMS_LICENSE_RENEWAL_PAYMENT]: EChannelType.SMS,
  [EDebtPaymentType.SMS_RECURRENT_BILLED]: EChannelType.SMS,
  [EDebtPaymentType.SMS_TEMPLATE_BILLED]: EChannelType.SMS,
  [EDebtPaymentType.MAX_BOT_LICENSE_INIT_PAYMENT]: EChannelType.MAX_BOT,
  [EDebtPaymentType.MAX_BOT_LICENSE_RENEWAL_PAYMENT]: EChannelType.MAX_BOT,
  [EDebtPaymentType.MAX_LICENSE_INIT_PAYMENT]: EChannelType.MAX,
  [EDebtPaymentType.MAX_LICENSE_RENEWAL_PAYMENT]: EChannelType.MAX,
  [EDebtPaymentType.TELEGRAM_LICENSE_INIT_PAYMENT]: EChannelType.TELEGRAM,
  [EDebtPaymentType.TELEGRAM_LICENSE_RENEWAL_PAYMENT]: EChannelType.TELEGRAM,
};

export type TDebtPaymentType = keyof typeof EDebtPaymentType;

export type TPaymentDebtItems = {
  totalAmount: number;
  paymentDebtsGroups: TPaymentDebtGroup[];
};

type TPaymentDetails = {
  subject?: string;
  mauPackageCount?: number;
  exceededMauCount?: number;
  mauCount?: number;
  amauCount?: number;
  periodStarted?: string;
  channelAttribute?: string;
  mobileOperator?: EOperatorName;
  period?: string;
  templateId?: number;
  templateName?: string;
};

export type TPaymentDebt = {
  createdAt: string;
  cancelAt: string;
  paymentType: TDebtPaymentType;
  tenantId: number;
  amount: number;
  currency: TCurrency;
  details: TPaymentDetails;
  expirationTime: string;
  expiredAt: string;
};

export type TPaymentDebtGroup = {
  createdAt: string;
  cancelAt: string;
  paymentType: TDebtPaymentType;
  totalAmount: number;
  paymentDebts: TPaymentDebt[];
};

export type TNextPaymentItems = {
  totalAmount: number;
  nextPaymentsGroups: TNextPaymentGroup[];
};

export type TNextPaymentGroup = {
  paymentDate: string;
  expireAt: string;
  paymentType: TDebtPaymentType;
  totalAmount: number;
  nextPayments: TNextPayment[];
};

export type TNextPayment = {
  paymentDate: string;
  expireAt: string;
  paymentType: TDebtPaymentType;
  tenantId: number;
  amount: number;
  currency: TCurrency;
  details: TPaymentDetails;
};

export type TDocumentFilters = {
  period: TPeriodPickerValue;
  filter?: string;
  tenantId?: TItemId | null;
  isSupport: boolean;
  types: TDocumentType | TDocumentType[];
};
